export interface RatingResponse {
    average: number;
    count: number;
}

/** A rating the server did not accept. status 401 = the visitor must log in first. */
export class RatingError extends Error {
    status: number;
    constructor(message: string, status: number) {
        super(message);
        this.status = status;
    }
}

/**
 * Sends a rating (POST /api/post/submit-rating → WpInterface, needs the login cookie).
 * Throws RatingError when it was not saved; it used to resolve with { 0, 0 } instead, so the UI
 * said «saved» (and showed 0 votes) although nothing was stored.
 */
const addPostRating = async (
    postId: number,
    userId: string,
    rating: number,
): Promise<RatingResponse> => {
    const response = await fetch('/api/post/submit-rating', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ postId, userId, rating }),
    });

    const result = await response.json().catch(() => ({}));
    if (!response.ok || !result?.data?.updatePostRatings) {
        throw new RatingError(result?.message || 'ثبت امتیاز انجام نشد.', response.status);
    }
    return {
        average: Number(result.data.updatePostRatings.average) || 0,
        count: Number(result.data.updatePostRatings.count) || 0,
    };
};

export default addPostRating;
